import { unitBaseTypeEnum } from "../../unit-base-type-enum";
import { Column, UnitAmount } from "./models/column";
import { Part } from "./models/part";

export class ColumnBaseService {

    computeTotalAmountsForParts(parts: Part<Column<any, any, any, any>, any>[]): UnitAmount[] {
        let unitAmounts = [];
        if (parts) {
            this.computeAmountsForParts(parts);
            const columns = parts.map(p => p.columns).flat();
            columns.forEach(column => {
                column.amountOfUnits.forEach(unitAmount => {
                    const foundExisting = unitAmounts.find(u => u.type === unitAmount.type);
                    if (foundExisting) {
                        foundExisting.amount = foundExisting.amount + unitAmount.amount;
                    } else {
                        unitAmounts.push({
                            type: unitAmount.type,
                            amount: unitAmount.amount
                        })
                    }
                });
            });
        }
        return unitAmounts;
    }

    computeAmountsForParts(parts: Part<Column<any, any, any, any>, any>[]): void {
        if (parts) {
            parts.forEach(p => p.columns.forEach(column => {
                let amountOfUnits = [];
                if (column.unitsAndAmenities) {
                    column.unitsAndAmenities.forEach(ua => {
                        if(ua.units){
                            ua.units.forEach(u => {
                                this.addOrSumUpExistingAmount(amountOfUnits, u.baseType);
                            })
                        }
                    })
                }
                column.amountOfUnits = amountOfUnits;
            }));
        }
    }

    addOrSumUpExistingAmount(existingAmountsOfUnits: UnitAmount[], unitBaseTypeToAdd: unitBaseTypeEnum) {
        if (unitBaseTypeToAdd) {
            const findUnit = existingAmountsOfUnits.find(s => s.type === unitBaseTypeToAdd);
            if (findUnit) {
                findUnit.amount += 1;
            } else {
                existingAmountsOfUnits.push({ type: unitBaseTypeToAdd, amount: 1 });
            }
        }
    }
}